import { Group } from '@mantine/core';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { technologicalTransferTypes } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferSchema } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { EnumSelectControl, TextInputControl } from '@/core/components';

export interface TechnologicalTransferTypeSelectControlProps {
  isSubmitting: boolean;
  watch: UseFormWatch<TechnologicalTransferSchema>;
}

export const TechnologicalTransferTypeSelectControl = (props: TechnologicalTransferTypeSelectControlProps) => {
  const { isSubmitting, watch } = props;
  const { t } = useTranslation();

  const typeField = watch('type');
  const showTypeNameField = typeField === 'OTHER';

  return (
    <Group>
      <EnumSelectControl<TechnologicalTransferSchema>
        withAsterisk
        name="type"
        label={t('technologicalTransfers.form.fields.type')}
        isSubmitting={isSubmitting}
        options={technologicalTransferTypes.map(type => ({
          value: type,
          label: t(`technologicalTransfers.typeEnum.${type}`),
        }))}
      />
      {showTypeNameField && (
        <TextInputControl<TechnologicalTransferSchema>
          withAsterisk
          name="typeName"
          label={t('technologicalTransfers.form.fields.typeName')}
          isSubmitting={isSubmitting}
        />
      )}
    </Group>
  );
};
